<template>
  <Loader v-if="!$store.getters['global/isLoaded']"></Loader>
  <router-view v-else></router-view>
</template>

<style lang="scss">
// 3rd party plugins css
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~socicon/css/socicon.css";
@import "~animate.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";
@import "assets/css/custom.css";
@import "assets/css/btnStyle.css";

// Main demo style scss
@import "assets/css/style.vue.rtl";

// Check documentation for RTL css
// Update HTML with RTL attribute at public/index.html

/*@import "assets/css/style.vue.rtl";*/
</style>

<script>
import { OVERRIDE_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import Loader from "@/view/content/PreLoader";

export default {
  name: "MetronicVue",
  components:{
    Loader
  },
  mounted() {
    /**
     * this is to override the layout config using saved data from localStorage
     * remove this to use config only from static json (@/core/config/layout.config.json)
     */
    this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);
    // this.requestApiGet('abilitiesType').then(response => {
    //   this.$ability.update([
    //     { subject: 'all', actions: response.data}
    //   ])
    // })
  }
};
</script>
